import React from 'react'
import { Route, Switch } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'

import { history } from '../../utils/history'

import LayoutV2 from '../layout_v2/Index'
import Admin from '../Admin/Index'

const Layout = () =>
 {
    return (
      <ConnectedRouter history={history}>
        <Switch>
          <Route exact path="/admin/*" component={Admin} />
          <Route exact path="/" component={LayoutV2} />
          <Route exact path="/*" component={LayoutV2} />
        </Switch>
      </ConnectedRouter>
    )
  }

export default Layout
